@defer (when value()) {
<app-resource-form-card
  [title]="service.title()"
  [resource]="resource"
  [createButton]="access()?.image?.actions?.create"
  [detailed]="detailed()"
  [list]="true"
>
  <p-table
    [value]="value() ?? []"
    [paginator]="true"
    [rows]="5"
    [rowsPerPageOptions]="[5, 10, 20]"
    [scrollable]="true"
    scrollHeight="flex"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th pSortableColumn="name" class="min-w-52">
          Nombre <p-sortIcon field="name" />
        </th>
        @if (detailed()) {
        <th class="min-w-52">Descripción</th>
        <th pSortableColumn="duration" class="min-w-32">
          Duración <p-sortIcon field="duration" />
        </th>
        }
        <th class="min-w-28">Imagen</th>
        @if (detailed()) {
        <th pSortableColumn="orientation" class="min-w-36">
          Orientación <p-sortIcon field="orientation" />
        </th>
        @if (access()?.contract?.actions?.read) {
        <th pSortableColumn="contract.name" class="min-w-52">
          Contrato <p-sortIcon field="contract.name" />
        </th>
        } @if (access()?.branch?.actions?.read) {
        <th pSortableColumn="branch" class="min-w-32">
          Sucursal <p-sortIcon field="branch" />
        </th>
        } }
        <th class="action">Acciones</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-value>
      <tr>
        <td class="max-w-min">{{ value.formattedName }}</td>
        @if (detailed()) {
        <td>{{ value.formattedDescription }}</td>
        <td>{{ value.formattedDuration }}</td>
        }
        <td>
          @if (service.isImage(value)) {
          <p-image
            [src]="value.formattedImageURL"
            [alt]="value.name"
            width="500"
            [preview]="true"
          />
          } @else if (service.isVideo(value)) {
          <video
            [src]="value.formattedImageURL"
            controls
            width="500"
            class="resource-thumbnail"
          ></video>
          } @else {
          <div class="no-preview-placeholder">
            <i class="pi pi-file"></i> No hay previsualización
          </div>
          }
        </td>
        @if (detailed()) {
        <td>{{ value.formattedOrientation }}</td>
        @if (access()?.contract?.actions?.read) {
        <td>{{ value.formattedContract }}</td>
        } @if (access()?.branch?.actions?.read) {
        <td>{{ value.formattedBranch }}</td>
        } }
        <td>
          <app-resource-button-group
            [resource]="resource"
            [resourceId]="value._id"
            [iconOnly]="true"
            [detailsButton]="true"
            [editButton]="access()?.image?.actions?.update"
            [deleteButton]="access()?.image?.actions?.delete"
          >
          </app-resource-button-group>
        </td>
      </tr>
    </ng-template>
  </p-table>
</app-resource-form-card>
}
